import {LOAD_ERRORS, MARK_ERROR_AS_SHOWN} from './types'

export const loadErrors = (errors) => dispatch => {
    dispatch({
        type:LOAD_ERRORS,
        payload:errors
    });
}

export const markErrorsAsShown = () => dispatch => {
    dispatch({
        type:MARK_ERROR_AS_SHOWN,
    })
}